
import type { PropType } from 'vue'
import type { BulkActionMessages } from '../../../models'
import { defineComponent } from 'vue'
import EpbBulkActionToolbar from './epb-bulk-action-toolbar.component.vue'
import { initBulkActionProvider } from './init-bulk-action-provider'

export default defineComponent({
  name: 'EpbBulkAction',
  components: {
    EpbBulkActionToolbar,
  },
  props: {
    messages: {
      type: Object as PropType<BulkActionMessages>,
      default: () => ({}),
    },
  },
  emits: {
    clearAll: () => {},
    close: () => {},
  },
  setup(p) {
    const { isToolBarOpen, toggleToolbar, isSelected, selectItem, unSelectItem } =
      initBulkActionProvider()

    return {
      baseClass: 'epb-bulk-action',
      isToolBarOpen,
      toggleToolbar,
      isSelected,
      selectItem,
      unSelectItem,
    }
  },
})
